import { Component, Input } from '@angular/core';
import { ValidatorFn } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';

import { InputChipsComponent } from '../input-chips/input-chips.component';

@Component({
  selector: 'app-custom-validator-chips',
  templateUrl: '../input-chips/input-chips.component.html',
  styleUrls: ['../input-chips/input-chips.component.scss'],
  standalone: false,
})
export class CustomValidatorChipsComponent extends InputChipsComponent {
  @Input() public customFormat = false;
  @Input() public formatData!: (value: string) => string[];
  @Input() public customValidatorFn!: (data: string[]) => ValidatorFn;

  add(event: MatChipInputEvent): void {
    const value = event.value || '';
    if (value) {
      // setting validator dynamically to avoid eager validation
      this.setValidator(this.customValidatorFn(this.chips));

      if (this.control.valid) {
        if (this.customFormat) {
          this.chips.push(...this.formatData(value));
        } else {
          this.chips.push(value);
        }
        event.chipInput!.clear();
        this.clearValidator();
      }
    }
  }

  setValidator(customValidatorFun: any): void {
    this.control.setValidators(customValidatorFun);
    this.control.updateValueAndValidity({ onlySelf: true });
  }

  clearValidator(): void {
    this.control.clearValidators();
    this.control.updateValueAndValidity({ onlySelf: true });
  }
}
